import { useEffect, useRef } from "react";
import {
  ADSENSE_CLIENT,
  pushAdSenseAdWithRetry,
} from "../utility/googleAds";

const GoogleAdUnit = ({
  adSlot,
  adClient = ADSENSE_CLIENT,
  style = { display: "block" },
  layoutKey,
  fullWidthResponsive = true,
  className = "",
}) => {
  const adRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const adElement = adRef.current;

    const initAd = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));

      if (!cancelled && adElement) {
        await pushAdSenseAdWithRetry(adElement);
      }
    };

    initAd();

    return () => {
      cancelled = true;
      if (adElement) {
        adElement.removeAttribute("data-adsense-initialized");
      }
    };
  }, [adSlot]);

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle google-ad-unit ${className}`.trim()}
      style={style}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      {...(layoutKey ? { "data-ad-layout-key": layoutKey } : {})}
      {...(fullWidthResponsive ? { "data-full-width-responsive": "true" } : {})}
    />
  );
};

export default GoogleAdUnit;
